// Lista INLINE de quem ainda não praticou um ato do rito — conflito, triagem,
// fechamento de oitivas, voto no membro externo. Quatro consumidores, um componente.
//
// Saiu do `CaseDetailPage` em 2026-08-18, quando ganhou comportamento próprio (a marca
// "(você)") e portanto virou algo com teste próprio a escrever. Enquanto era só
// `ids.join(', ')` dentro da página, morar lá era razoável; deixou de ser no instante em
// que passou a DECIDIR alguma coisa.

import type { useTranslation } from 'react-i18next';

/** Projeção de `GET /api/comite/members` que esta lista consome. */
export interface MembroRotulo {
  id: string;
  email: string;
}

export function PendentesLista({
  ids,
  members,
  t,
  labelKey,
  extra,
  meuId,
}: {
  ids: ReadonlyArray<string>;
  members: ReadonlyArray<MembroRotulo> | null;
  t: ReturnType<typeof useTranslation>['t'];
  labelKey: string;
  /** Interpolações extras do rótulo (ex.: o NOME do indicado a membro externo). O
   *  `count` continua sendo posto aqui dentro — quem chama não precisa saber que o
   *  i18n pluraliza por ele. */
  extra?: Record<string, string>;
  /** Id de quem está lendo, para marcar a própria linha. Ver o 🔴 abaixo. */
  meuId?: string;
}): JSX.Element | null {
  if (ids.length === 0) return null;
  const emailPorId = new Map((members ?? []).map((m) => [m.id, m.email]));
  return (
    <p className="auditora-banner__pendentes">
      {/* 🔴 INLINE, não `<ul>` (operador, 2026-08-13: "está muito amontoado").
          Cinco membros pendentes rendiam CINCO linhas de mono, e eram o volume do
          painel — mais espaço que a ação que a pessoa precisa ler.
          Vírgulas em uma linha guardam a MESMA informação (quem falta, e quantos)
          numa fração da altura. Nada foi escondido: o pedido anterior era
          justamente exibir quem falta, e continua exibido por extenso. */}
      <strong>{t(labelKey, { count: ids.length, ...extra })}</strong>{' '}
      {/* 🔴 A PRÓPRIA PESSOA VEM MARCADA (relato do operador, 2026-08-18).
          O relato foi "declarei o conflito e continua exibindo que estou pendente" — e o
          servidor estava CERTO: quem declarou saiu da lista de conflito e seguia na de
          triagem, que é outro ato. O defeito era de LEITURA: duas listas com a mesma
          forma, o mesmo peso e o e-mail da pessoa solto no meio. Quem bate o olho lê o
          próprio endereço numa pendência e conclui que o ato anterior não pegou.
          Marcar quem é você transforma "há um nome igual ao meu numa lista" em "esta
          pendência é minha, aquela não". O painel de classificações da TriagemPage já
          fazia isso; aqui faltava. */}
      <span className="auditora-banner__pendentes-nomes">
        {ids.map((id, i) => (
          <span key={id}>
            {i > 0 && ', '}
            {emailPorId.get(id) ?? id}
            {id === meuId && (
              <span className="auditora-banner__eu"> {t('ia_auditora.banner.voce')}</span>
            )}
          </span>
        ))}
      </span>
    </p>
  );
}
